import { d as t } from "../internals/descriptors.js";
import { d as r } from "../internals/define-built-in-accessor.js";
import { i as e } from "../internals/is-object.js";
import { t as o } from "../internals/to-object.js";
import { r as i } from "../internals/require-object-coercible.js";
var s = Object.getPrototypeOf,
  n = Object.setPrototypeOf,
  c = Object.prototype,
  a = "__proto__";
if (t && s && n && !(a in c)) try {
  r(c, a, {
    configurable: !0,
    get: function get() {
      return s(o(this));
    },
    set: function set(t) {
      var r = i(this);
      (e(t) || null === t) && e(r) && n(r, t);
    }
  });
} catch (t) {}